import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const MonitorsDiningPhilosophers = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Monitors: Solution to Dining Philosophers problem"
    videos={[
      "https://www.youtube.com/embed/ufdQ0GR855M",
      "https://www.youtube.com/embed/wJc-YF_Hb2s"
    ]}
    takeaways={[]}
    questions={[]}
    exampleVideos={[]}
  />
);
}

export default MonitorsDiningPhilosophers;
